export const formatRole = (role: string) => {
  if (!role) return '';
  if (role === 'read_only') return 'Read only';
  return role.charAt(0).toUpperCase() + role.slice(1);
};
